import * as yup from "yup";

import { FORM_FIELDS } from "@constants/form";
import {
  futureDateWithTodayValidation,
  pastDateWithTodayValidation,
} from "@validations/utils";

export const GENERAL_INFO = FORM_FIELDS.EMPLOYEE.GENERAL_INFO;

// Alternative approach: exclude Latin instead of including all Bengali
export const banglaTextFormat =
  /^(?!.*[A-Za-z])[\u09E6-\u09EF\u0980-\u09FF\u200C\u200D\s!"#$%&'()*+,\-./:;<=>?@\[\\\]^_`{|}~]+$/;
const nidNumberFormat = /^(?:\d{10}|\d{13}|\d{17})$/;
export const mobileNumberFormat = /(^(\+88|0088)?(01){1}[3456789]{1}(\d){8})$/;
export const emailFormat = /^[^\s@]+@[^\s@]+\.[a-zA-Z]{2,}$/;

export const generalInfoValidation = yup.object().shape({
  // general info
  [GENERAL_INFO.NAME_IN_ENGLISH]: yup
    .string()
    .required("Please provide employee name (In English)"),
  // .max(50, "No longer than 50 character"),
  [GENERAL_INFO.NAME_IN_BANGLA]: yup
    .string()
    .required("Name is a required field")
    .matches(banglaTextFormat, "Please provide employee name(In Bangla)"),
  // .max(50, "No longer than 50 character"),
  [GENERAL_INFO.NID_NO]: yup
    .string()
    .required("Please provide a valid NID No.")
    .matches(
      nidNumberFormat,
      "Please provide NID No. containing 10, 13 or 17 numbers",
    ),
  [GENERAL_INFO.MOBILE_NO]: yup
    .string()
    .required("Please provide a valid Mobile No.")
    .matches(mobileNumberFormat, "Mobile Number is not valid"),
  [GENERAL_INFO.EMAIL]: yup
    .string()
    .required("E-mail address is required")
    // .email("E-mail is not valid")
    .matches(emailFormat, "E-mail is not valid")
    .max(50, "No longer than 50 character"),
  [GENERAL_INFO.DATE_OF_BIRTH]: yup
    .string()
    .test("validator-birth-date", pastDateWithTodayValidation)
    .required("Please provide a valid Date of Birth"),
  [GENERAL_INFO.DATE_OF_DEATH]: yup
    .string()
    .test("validator-death-date", pastDateWithTodayValidation)
    .notRequired()
    .nullable(),
  [GENERAL_INFO.GENDER]: yup.string().required("Please provide gender"),
  [GENERAL_INFO.RELIGION]: yup
    .number()
    .typeError("Please provide employee religion")
    .required("Please provide employee religion"),
  [GENERAL_INFO.HOME_DISTRICT]: yup
    .number()
    .typeError("Please provide home district")
    .required("Please provide home district"),
  [GENERAL_INFO.MARITAL_STATUS]: yup
    .number()
    .typeError("Please provide marital status")
    .required("Please provide marital status"),
  [GENERAL_INFO.BLOOD_GROUP]: yup
    .number()
    .typeError("Please provide a valid Blood Group")
    .required("Please provide a valid Blood Group"),
  [GENERAL_INFO.FREEDOM_FIGHTER]: yup.boolean(),

  // job info
  [GENERAL_INFO.EMPLOYEE_ID]: yup
    .string()
    .required("Please provide employee ID"),
  // [GENERAL_INFO.EMPLOYMENT_TYPE]: yup.boolean(),
  // [GENERAL_INFO.EMPLOYEE_TYPE]: yup
  //   .number()
  //   .required("Please provide employee type"),
  [GENERAL_INFO.BATCH]: yup
    .string()
    // .required("Please provide batch")
    .max(4, "No longer than 4 character"),
  [GENERAL_INFO.WING_DESK_IO_E0]: yup
    .number()
    .required("Please provide Wing/Desk/I.0/E.O"),
  [GENERAL_INFO.DESIGNATION]: yup
    .number()
    .required("Please provide designation"),
  [GENERAL_INFO.GRADE]: yup.number().required("Please provide grade"),
  [GENERAL_INFO.POSITION]: yup.number().required("Please provide position"),
  // [GENERAL_INFO.POSTING_PLACE]: yup
  //   .string()
  //   .required("Please provide posting place")
  //   .max(50, "No longer than 50 character"),
  // [GENERAL_INFO.WORKING_PLACE]: yup
  //   .string()
  //   .required("Please provide working place")
  //   .max(50, "No longer than 50 character"),
  // [GENERAL_INFO.ORDER_DATE]: yup
  //   .string()
  //   .test("validator-order-date", pastDateWithTodayValidation)
  //   .required("Please provide order date"),

  // joining info
  [GENERAL_INFO.JOINING_DATE]: yup
    .string()
    .test("validator-joining-date", pastDateWithTodayValidation)
    .required("Please provide joining date"),
  // [GENERAL_INFO.DATE_OF_RESPONSIBILITY_TAKEOVER]: yup
  //   .string()
  //   .test("validator-responsibility-date", pastDateWithTodayValidation)
  //   .required("Please provide date of responsibility takeover"),
  // [GENERAL_INFO.PRL_DATE]: yup
  //   .string()
  //   .test("validator-prl-date", futureDateWithTodayValidation)
  //   .required("Please provide PRL date"),
  // [GENERAL_INFO.CONFIRMATION_GO_DATE]: yup
  //   .string()
  //   .test("validator-confirmation-date", pastDateWithTodayValidation)
  //   .required("Please provide confirmation G.0 date"),
  // [GENERAL_INFO.LAST_PROMOTION_DATE]: yup
  //   .string()
  //   .test("validator-last-date", pastDateWithTodayValidation)
  //   .nullable(),
  // [GENERAL_INFO.DEPUTATION_DATE]: yup
  //   .string()
  //   .test("validator-deputation-date", pastDateWithTodayValidation)
  //   .required("Please provide deputation date"),

  //  -----------------
  // [GENERAL_INFO.CONTRACT_EXPIRY_DATE]: yup
  //   .string()
  //   .test("validator-contract-date", pastDateWithTodayValidation)
  //   .notRequired()
  //   .nullable(),
  [GENERAL_INFO.CONTRACT_EXPIRY_DATE]: yup
    .string()
    .test("validator-contract-date", futureDateWithTodayValidation)
    .when([GENERAL_INFO.EMPLOYEE_TYPE], {
      is: 3,
      then: (schema) => schema.required("Please provide contract Expiry date"),
      otherwise: (schema) => schema.notRequired().nullable(),
    }),

  [GENERAL_INFO.RANK]: yup.string(),
  [GENERAL_INFO.BASIC_SALARY]: yup
    .number()
    .typeError("Please provide a valid number")
    .nullable()
    .moreThan(0, "Salary cannot be negative")
    .transform((_, val) => {
      if (val === "" || val === null) return null;
      return Number(val);
    }),
  //  -----------------

  // [GENERAL_INFO.PROBATION_END_DATE]: yup.string().nullable(),
  [GENERAL_INFO.ORGANIZATION]: yup
    .string()
    // .required("Please provide organization")
    .max(100, "No longer than 100 character"),
  // [GENERAL_INFO.ON_PROBATION]: yup.boolean(),
});

export type GeneralInfoFormDataType = yup.InferType<
  typeof generalInfoValidation
>;
